<template>
  <div class="page-container" ref="Home" id="homecontainer">
    <div class="bigscroller">
      <Menu />
      <MobileMenu />
      <section id="campaigns">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <!-- <BannerViveLatino /> -->
        <MobileCampaign />
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <section id="history">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <History />
        <OurEmperor />
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <section id="beer">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <Beer />
        <MobileBeer />
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <!-- <section id="sustainable">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <Sustainable />
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section> -->
      <div class="mRetailers">
        <section id="retailers">
          <span
            class="top watcher"
            v-observe-visibility="visibilityChanged"
          ></span>
          <Retailers />
          <MobileRetailers />
          <span
            class="bottom watcher"
            v-observe-visibility="visibilityChanged"
          ></span>
        </section>
        <Footer />
      </div>
    </div>
    <ModalAH
      v-show="showModal"
      wichModal="aah"
      @close="showModal = false"
    ></ModalAH>
  </div>
</template>

<script>
import Menu from "@/components/MenuM";
import MobileMenu from "@/components/MobileMenu";

import Retailers from "@/components/Retailers.vue";
import MobileRetailers from "@/components/MobileRetailersM.vue";

import mhlcenteredlogo from "@/assets/Indio_Logo_Simple.png";

import VueScrollTo from "vue-scrollto";

import { mapActions, mapGetters } from "vuex";

import Footer from "@/components/FooterHome";
import MobileCampaign from "@/components/MobileCampaign";
import MobileBeer from "@/components/MobileBeer";
import Beer from "@/components/Beer";
import Sustainable from "@/components/Sustainable";
import History from "@/components/History";
import OurEmperor from "@/components/OurEmperor";
import tagFunctions from "@/utils/tagFunctions.js";
import BannerViveLatino from "@/components/BannerViveLatino";
import ModalAH from "@/components/ModalAH.vue";
const utm1 = {
  utm_content: "QR_AvisoAlcohol",
  utm_medium: "PopUp",
  utm_source: "Lata-Indio",
};
export default {
  name: "Home",
  props: ["id"],
  components: {
    Menu,
    MobileMenu,
    Retailers,
    MobileRetailers,
    Footer,
    MobileCampaign,
    MobileBeer,
    Beer,
    Sustainable,
    History,
    OurEmperor,
    BannerViveLatino,
    ModalAH,
  },
  computed: {
    ...mapGetters([
      "getActiveSection",
      "getTriggerSpring",
      "getEdgeScrolling",
      "getScrollMotion",
    ]),
  },
  created() {},
  data() {
    return {
      showModal: false,
      fixedLel: true,
      mhlcenteredlogoImage: mhlcenteredlogo,
      placesDirections: {
        campaignUp: (scrolled) => {
          this.setActiveSection("campaigns");
          document.getElementById("app").scroll(0, scrolled);
        },
        campaignDown: (scrolled) => {
          this.setActiveSection("campaigns");
          document.getElementById("app").scroll(0, scrolled);
        },
        beerUp: (scrolled) => {
          this.setActiveSection("beer");
          document.getElementById("app").scroll(0, scrolled);
        },
        beerDown: (scrolled) => {
          this.setActiveSection("beer");
          document.getElementById("app").scroll(0, scrolled);
        },
        retailerUp: (scrolled) => {
          this.setActiveSection("retailers");
          document.getElementById("app").scroll(0, scrolled);
        },
        retailerDown: (scrolled) => {
          this.setActiveSection("retailers");
          document.getElementById("app").scroll(0, scrolled);
        },
      },
    };
  },
  mounted() {
    tagFunctions.evAuthenticationPush("Indio");
    tagFunctions.evPageViewPush("Home");
    //this.checkRouteForInitialScroll();
    VueScrollTo.scrollTo(`#app`, 1, {
      container: "body",
      easing: "linear",
      offset: 0,
      force: true,
      cancelable: true,
      // onStart: function(element) {},
      // onDone: function(element) {},
      // onCancel: function() {},
      x: false,
      y: true,
    });

    const { utm_source, utm_medium, utm_content } = this.$route.query;
    if (
      utm1["utm_source"] === utm_source &&
      utm1["utm_content"] === utm_content &&
      utm1["utm_medium"] === utm_medium
    ) {
      setTimeout(() => {
        this.showModal = true;
      }, 3000);
    }
  },
  methods: {
    ...mapActions({
      goToSection: "goToSection",
      setActiveSection: "setActiveSection",
      resetEdgeScrollingAction: "resetEdgeScrolling",
      setEdgeScrollingAction: "setEdgeScrolling",
    }),
    popUpModal(modalType) {
      this.showModal = true;
      this.wichModal = modalType;
    },
    visibilityChanged(isVisible, entry) {
      //  console.log("isvisible1",entry.target.offsetParent)
      if (isVisible) {
        const query = localStorage.getItem('query');
        this.$router
          .push({ path: entry.target.offsetParent.id, query: {...JSON.parse(query)} })
          .catch((err) => {
            // Ignore the vuex err regarding  navigating to the page they are already on.
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              // But print any other errors to the console
              throw err;
            }
          });
        this.setActiveSection({
          willScroll: false,
          section: entry.target.offsetParent.id,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/home.scss";
@import "~@/styles/variables.scss";
</style>
